// https://www.figma.com/file/q7KlcLyYFswO2QB3I4BWmE/Interests-Graph-on-Web?node-id=0%3A1
import { useEffect } from 'react'
import { css, cx, useTheme } from '@fable/theme'
import { Redirect } from '@fable/legacy'
import { useLocation } from 'react-router-dom'
import {
  useTypedSelector,
  useActions,
  useLoadReferral,
} from '../../../../hooks'
import { isFalseyObject } from '../../../../utils'
import Loader, { LoaderType } from '../../../../components/loader'
import ProfileHeader from '../../components/profile/ProfileHeader'
import ProfileContentPrivate from '../../components/profile/ProfileContentPrivate'
import ProfileContentPublic from '../../components/profile/ProfileContentPublic'
import ProfileConnections from '../../../../components/profile/profile_connections/ProfileConnections'
import Sidebar from '../../../../components/sidebar/Sidebar'
import { Page } from '../../../../components/Page'
import { InviteUserCard } from 'components/invite_user_card/InviteUserCard'

/* This component should be last in the list of <Route> components in App.js
If a user is not found, it will redirect to the 404 page */
const Profile = () => {
  const { user } = useTypedSelector(({ social }) => social)
  const { profile } = useTypedSelector(({ user }) => user)
  const { isVerifying, isAuthenticated } = useTypedSelector(({ auth }) => auth)
  const { userLookup, userLookupClear } = useActions()
  const { pathname } = useLocation()
  const { mediaQueries } = useTheme()
  const { referralUser, enabled: referralEnabled } = useLoadReferral({
    enabled: true,
  })
  const loggedInUserId = profile.data?.id
  const viewedUserId = user.data?.id || ''
  const isViewingSelf = viewedUserId === loggedInUserId

  useEffect(() => {
    if (isFalseyObject(user) && !isVerifying) {
      userLookup(pathname)
    }
  }, [userLookup, pathname, user, userLookupClear, isVerifying])

  useEffect(
    () => () => {
      // Clear data on unmount
      userLookupClear()
    },
    [userLookupClear]
  )

  if (!user.data && user.loading) {
    return (
      <div className="screen-height">
        <Loader type={LoaderType.fullscreen} />
      </div>
    )
  }

  if (user.error) {
    return <Redirect to="/404" />
  }

  return (
    <Page
      head={{
        title: user.data?.display_name,
        image: user.data?.pic,
        canonical: true,
        url: user.data?.url,
      }}
      className={cx(
        'profile',
        css`
          margin: 20px auto 0;
          padding-top: ${!isAuthenticated && referralEnabled ? 80 : 0}px;
        `
      )}
    >
      <ProfileHeader />
      <div
        className={css`
          margin-top: 40px;
          ${mediaQueries.tablet} {
            padding-bottom: 40px;
          }
        `}
      >
        {!isViewingSelf && user.data?.private_profile ? (
          <ProfileContentPrivate />
        ) : (
          <ProfileContentPublic />
        )}
      </div>
      <Sidebar title="My connections">
        <ProfileConnections userId={viewedUserId} />
      </Sidebar>
      {!isAuthenticated && !!referralUser ? (
        <InviteUserCard
          className={css`
            padding-top: 72px !important;
          `}
          user={referralUser}
        />
      ) : null}
    </Page>
  )
}

export default Profile
